//////LIBRARY//////
import React, { useEffect, useState, Fragment, useMemo } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { bindActionCreators } from 'redux'
import { cloneDeep, isEmpty, isUndefined, map, isEqual, isNull, find, isNumber, set } from 'lodash'
//////COMPONENTS//////
import Table from '../../components/Table'
import { KioskPricesManagerNested } from './Components'
import {
	campaignPriceActionCreators,
	campaignPromoActionCreators,
	kioskPricesManagerActionCreators,
	columnsActionCreators,
	tableActionCreators,
} from '../../store/actions'
import Button from '../../components/Ui/Buttons'
import Modals from '../../components/Modals'
import Tooltip from '../../components/Tooltip/Tooltip'
import DropdownCheckbox from '../../components/DropdownCheckbox'
import ToggleFilters from '../../components/Ui/ToggleFilters'
import { ActionWrapperElem, TextModal } from '../../theme/GlobalCss'
import { selectIdsUser } from '../../store/selectors/user'
import ImgButton from '../../components/Ui/ImgButton'
import theme from '../../theme/theme'
import PriceCampaignHandlerCreate from '../../components/PriceCampaignHandlerCreate'
import UseCheckAll from '../../hooks/UseCheckAll'
import userPrivileges from '../../constants/PrivilegesList'
import PromoCampaignHandlerCreate from '../../components/PromCampaignHandlerCreate'
import NestedUpdateCampaign from './Components/NestedUpdateCampaign'
import TooltipHelp from '../../components/TooltipHelp'
import urlExport from '../../constants/UrlExport'
import ValueCheck from '../../helpers/ValueCheck'
import TableTitle from '../../components/Table/components/TableTitle'
//////ASSETS//////
import Validation from '../../assets/icones/global/check.svg'
import Cancel from '../../assets/icones/global/close-white.svg'
import CreatePrice from '../../assets/icones/global/createPrice.svg'
import CreatePromo from '../../assets/icones/global/megaphone-white.svg'

//////STYLED//////
const UsersManagerWrapper = styled.div`
	position: relative;
`
const ButtonWrapper = styled.div`
	display: flex;
	height: 32px;
	width: 100%;
	justify-content: space-between;
`
//////STYLED//////

const KioskPricesManager = () => {
	const {
		user,
		translations,
		kioskPricesManager,
		kioskPricesFilters,
		campaign,
		userKioskPerimeter,
		successCreateCampaign,
		campaignErrors,
		successCreateCampaignPromo,
		campaignPromoErrors,
		campaignPromo,
		isSearchfieldUpdated,
		currentColumn,
		currentDir,
	} = useSelector(
		(state) => ({
			translations: state.languages.translations,
			kioskPerimeter: state.user.identity.kioskSelected,
			kioskPricesManager: state.kioskPricesManager,
			kioskPricesFilters: state.kioskPricesManager.header,
			campaign: state.campaignPrice.campaign,
			campaignPromo: state.campaignPromo.campaign,
			user: state.user,
			userIds: selectIdsUser(state),
			userKioskPerimeter: state.user.identity.kioskSelected,
			successCreateCampaign: state.campaignPrice.isSuccess || false,
			campaignErrors: state.campaignPrice.error?.data || [],
			successCreateCampaignPromo: state.campaignPromo.isSuccess || false,
			campaignPromoErrors: state.campaignPromo.error?.data || [],
			isSearchfieldUpdated: state.columns.isSearchfieldUpdated,
			currentColumn: state.columns.currentColumn,
			currentDir: state.columns.currentDir,
		}),
		shallowEqual
	)

	const actionsKioskPricesManager = bindActionCreators(kioskPricesManagerActionCreators, useDispatch())
	const campaignActions = bindActionCreators(campaignPriceActionCreators, useDispatch())
	const campaignPromoActions = bindActionCreators(campaignPromoActionCreators, useDispatch())
	const actionsColumns = bindActionCreators(columnsActionCreators, useDispatch())
	const actionsTable = bindActionCreators(tableActionCreators, useDispatch())

	// Filters
	const [prevFilter, setPrevFilter] = useState({})
	// Custom method to submit on radio change
	const handleSubmitRadioClose = (newFilters) => {
		// We want to use changed filters, not waiting for useEffect (sort of force method)
		const filt = {
			withFilters: true,
			...newFilters,
			userKioskScope: {
				kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
			},
		}
		actionsKioskPricesManager.postKioskPricesManager(filt, paging)
	}
	const [filters, setFilters, handleCheckElements] = UseCheckAll(prevFilter, handleSubmitRadioClose)

	// Data
	const [inputData, setInputData] = useState([])
	const [paging, setPaging] = useState({
		page: '0',
		size: '250',
		sort: 'kiosk.labelToManufacturer',
		nameDir: 'asc',
		sort_2: 'itemDistributor.item.family.label',
		nameDir_2: 'asc',
		sort_3: 'itemDistributor.item.brand.label',
		nameDir_3: 'asc',
		sort_4: 'itemDistributor.item.label',
		nameDir_4: 'asc',
	})

	// Modals
	const [nestedRow, setNestedRow] = useState({})
	const [showModalEditCampaign, setShowModalEditCampaign] = useState(false)
	const [showModalCancelCampaign, setShowModalCancelCampaign] = useState(false)

	const [showModalEditCampaignPromo, setShowModalEditCampaignPromo] = useState(false)

	// Search bar
	const [searchValue, setSearchValue] = useState()

	const [currentPerimeterKiosks, setCurrentPerimeterKiosks] = useState([])

	// Columns
	const [columns, setColumns] = useState([])

	//////////////////////////////////// HANDLER /////////////////////////////////////////////////////////

	const handleFilterSend = () => {
		const filtersIn = cloneDeep(filters)
		let searchFieldUpdated = {}
		let filtersOut = {}

		if (isSearchfieldUpdated) {
			searchFieldUpdated = {
				searchFieldUpdated: true,
			}
		} else {
			searchFieldUpdated = {
				searchFieldUpdated: false,
			}
		}
		filtersOut = { ...searchFieldUpdated, ...filtersIn }
		return {
			withFilters: true,
			...filtersOut,
			userKioskScope: {
				kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
			},
		}
	}

	const handlePriceOrPromo = (data, target) => {
		switch (target) {
			case 'price':
				handleModalEditCampaign(data)
				break
			case 'promo':
				handleModalPromo(data)
				break

			default:
				break
		}
	}

	const handleModalPromo = (dataRow) => {
		if (!dataRow.length) return // guard do nothing if no line was selected
		const checkItemFormat = {
			selectedItems: map(dataRow, (elem) => ({
				idItem: elem.idItem,
				idKiosk: elem.idKiosk,
			})),
			kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
			dateStart: moment().add(1, 'hours').toDate(),
			dateEnd: moment().add(1, 'weeks').toDate(),
			withTTC: filters.pricesTTC,
			idDistributor:
				find(filters.filtersSelection.distributors.filterElements, { active: true }).id ||
				filters.filtersSelection.distributors.filterElements[0].id,
			currency: dataRow[0].currency.symbol,
		}

		if (!showModalEditCampaignPromo && !isNull(dataRow)) {
			campaignPromoActions.checkCampaignPromo(checkItemFormat, 'byKiosk')
			//setShowModalEditCampaignPromo( true )
		} else {
			handleSubmitFilter(true)
			setShowModalEditCampaignPromo(false)
		}
	}

	const handleModalEditCampaign = (dataRow) => {
		if (!dataRow.length) return // guard do nothing if no line was selected
		const checkItemFormat = {
			selectedItems: map(dataRow, (elem) => ({
				idItem: elem.idItem,
				idKiosk: elem.idKiosk,
			})),
			kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
			dateStart: new Date(),
			withTTC: filters.pricesTTC,
			idDistributor:
				find(filters.filtersSelection.distributors.filterElements, { active: true }).id ||
				filters.filtersSelection.distributors.filterElements[0].id,
			currency: dataRow[0].currency.symbol,
		}

		if (!showModalEditCampaign && !isNull(dataRow)) {
			campaignActions.checkCampaign(checkItemFormat, 'byKiosk')
			//setShowModalEditCampaign( true )
		} else {
			handleSubmitFilter(true)
			setShowModalEditCampaign(false)
		}
	}

	const handlePagingSalesHistory = (paging) => {
		let sortMap = {}
		if (!isUndefined(currentColumn.value)) {
			sortMap = {
				sort: currentColumn.value,
				nameDir: currentDir.value,
			}
		} else {
			sortMap = {
				sort: 'kiosk.labelToManufacturer',
				nameDir: 'asc',
				sort_2: 'itemDistributor.item.family.label',
				nameDir_2: 'asc',
				sort_3: 'itemDistributor.item.brand.label',
				nameDir_3: 'asc',
				sort_4: 'itemDistributor.item.label',
				nameDir_4: 'asc',
			}
		}

		const pg = { ...paging, ...sortMap }
		setPaging(pg)
		actionsKioskPricesManager.postKioskPricesManager(handleFilterSend(), pg)
	}

	const handleSubmitFilter = (force = false) => {
		if (force) {
			actionsKioskPricesManager.postKioskPricesManager(handleFilterSend(), paging)
			return
		}

		if (isEqual(filters, prevFilter)) return

		setPrevFilter(filters)

		// Force reset paging at zero, in case when filters are preventing any pagination with current size
		let pg = cloneDeep(paging)
		if (isUndefined(pg)) {
			pg = {
				page: '0',
				size: '250',
				sort: 'kiosk.labelToManufacturer',
				nameDir: 'asc',
				sort_2: 'itemDistributor.item.family.label',
				nameDir_2: 'asc',
				sort_3: 'itemDistributor.item.brand.label',
				nameDir_3: 'asc',
				sort_4: 'itemDistributor.item.label',
				nameDir_4: 'asc',
			}
		} else {
			pg.page = '0'
		}
		setPaging(pg)

		actionsKioskPricesManager.postKioskPricesManager(handleFilterSend(), pg)
	}

	// SEARCH BAR

	const handleClickSearch = (refInput) => {
		setSearchValue(refInput.current.value)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleSearchEnter = (e, val) => {
		if (e.keyCode !== 13) return
		setSearchValue(val)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleWithTTC = () => {
		let filtersCP = cloneDeep(filters)
		filtersCP.pricesTTC = !filtersCP.pricesTTC

		setFilters(filtersCP)
		const str_filters = handleFilterSend()
		// Even if we set our hook, in HandleFilterSend,
		// TTC value is not actualised,
		// So we reset value here...
		str_filters.pricesTTC = filtersCP.pricesTTC
		str_filters.searchFieldByItem = searchValue
		actionsKioskPricesManager.postKioskPricesManager(str_filters, paging)
	}

	//////////////////////////////////// CONFIG /////////////////////////////////////////////////////////

	useEffect(() => {
		setColumns([
			{
				columnReferential: 'kioskPrice_kioskCode',
				dataHook: 'kioskCode',
				headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_tableHeader_kioskCode'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'kiosk.labelToManufacturer',
			},
			{
				columnReferential: 'kioskPrice_kioskLabel',
				dataHook: 'kioskName',
				headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_tableHeader_kioskName'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'kiosk.description',
			},
			{
				columnReferential: 'kioskPrice_clientKioskCode',
				dataHook: 'customerKioskCode',
				headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_tableHeader_kioskCustomerCode'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'kiosk.labelToOwner',
			},
			{
				columnReferential: 'kioskPrice_store',
				dataHook: 'storeLabelToDisplay',
				headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_tableHeader_storeLabel'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'kiosk.store.company.labelToDisplay',
			},
			{
				columnReferential: 'kioskPrice_family',
				dataHook: 'itemFamily.label',
				headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_tableHeader_familly'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'itemDistributor.item.family.label',
			},
			{
				columnReferential: 'kioskPrice_brand',
				dataHook: 'itemBrand.label',
				headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_tableHeader_brand'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'itemDistributor.item.brand.label',
			},
			{
				columnReferential: 'kioskPrice_type',
				dataHook: 'gasType',
				headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_tableHeader_type'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'itemDistributor.item.itemSpecificity.label',
			},
			{
				columnReferential: 'kioskPrice_itemCode',
				dataHook: 'codeItem',
				headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_tableHeader_itemCode'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'itemDistributor.item.label',
			},
			{
				columnReferential: 'kioskPrice_item',
				dataHook: 'itemLabelToDisplay',
				headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_tableHeader_itemLabel'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'itemDistributor.labelToDisplay',
			},
			{
				columnReferential: 'kioskPrice_salePrice',
				dataHook: 'itemPrice',
				headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_tableHeader_standardPrice'],
				sortable: true,
				isAuthorize: true,
				component: (props) => `${props.row.itemPrice}${props.row.currency.symbol}`,
				sortableId: 'price',
			},
			{
				columnReferential: 'kioskPrice_saleVAT',
				dataHook: 'itemVatRate',
				headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_tableHeader_vatRateItem'],
				sortable: true,
				isAuthorize: true,
				component: (props) => `${props.row.itemVatRate}%`,
				sortableId: 'itemDistributor.item.vatRate.rate',
			},
			{
				columnReferential: 'kioskPrice_consignmentPrice',
				dataHook: 'depositPrice',
				headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_tableHeader_depositPrice'],
				sortable: true,
				isAuthorize: true,
				component: (props) => ValueCheck.ValueCheck(props.row.depositPrice, '-', props.row.currency.symbol),
				sortableId: 'gbk.standardDepositPrice				',
			},
			{
				columnReferential: 'kioskPrice_consignmentVAT',
				dataHook: 'depositVatRate',
				headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_tableHeader_vatRateDeposit'],
				sortable: true,
				isAuthorize: true,
				component: (props) => ValueCheck.ValueCheck(props.row.depositVatRate, '-', '%'),
				sortableId: 'id',
			},
			{
				columnReferential: 'kioskPrice_nextSalePrice',
				dataHook: 'nextItemPrice',
				headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_tableHeader_nextItemPrice'],
				sortable: true,
				isAuthorize: true,
				component: (props) => ValueCheck.ValueCheck(props.row.nextItemPrice, '-', props.row.currency.symbol),
				sortableId: 'pucl.itemPriceTtc				',
			},
			{
				columnReferential: 'kioskPrice_nextConsignmentPrice',
				dataHook: 'nextDepositPrice',
				headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_tableHeader_nextDepostitPrice'],
				sortable: true,
				isAuthorize: true,
				component: (props) => ValueCheck.ValueCheck(props.row.nextDepositPrice, '-', props.row.currency.symbol),
				sortableId: 'pucl.depositPriceTtc			',
			},
			{
				columnReferential: 'kioskPrice_endDatePromoInProgress',
				dataHook: 'dateEndPromoInProgress',
				headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_tableHeader_dateEndPromoInProgress'],
				sortable: true,
				isAuthorize: true,
				component: (props) =>
					!isNull(props.row.dateEndPromoInProgress) ? moment(props.row.dateEndPromoInProgress).format('DD/MM/YYYY HH:mm') : '-',
				sortableId: 'pclpc.dateEnd',
			},
			{
				columnReferential: 'kioskPrice_salePricePromoInProgress',
				dataHook: 'standardPriceInPromoInProgress',
				headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_tableHeader_promoPriceItem'],
				sortable: true,
				isAuthorize: true,
				component: (props) => ValueCheck.ValueCheck(props.row.standardPriceInPromoInProgress, '-', props.row.currency.symbol),
				sortableId: 'pucl.itemPriceTtc',
			},
			{
				columnReferential: 'kioskPrice_consignmentPriceInProgress',
				dataHook: 'depositPriceInPromoInProgress',
				headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_tableHeader_promoPriceDeposit'],
				sortable: true,
				isAuthorize: true,
				component: (props) => ValueCheck.ValueCheck(props.row.depositPriceInPromoInProgress, '-', props.row.currency.symbol),
				sortableId: 'pcl.depositPriceTtc',
			},
			{
				columnReferential: 'kioskPrice_remainingStock',
				dataHook: 'remainingStock',
				headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_tableHeader_remainingAllocatedStock'],
				sortable: true,
				isAuthorize: true,
				component: (props) =>
					`${isNumber(props.row.remainingStock) ? props.row.remainingStock : ''} - ${
						isNumber(props.row.allocatedStock) ? props.row.allocatedStock : ''
					}`,
				sortableId: 'pcl.allocatedStock',
			},
			{
				columnReferential: 'kioskPrice_stockAllocatedDate',
				dataHook: 'dateAllocatedStockReachedInPromoInProgress',
				headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_tableHeader_dateAllocatedStock'],
				sortable: true,
				isAuthorize: true,
				component: (props) =>
					!isNull(props.row.dateAllocatedStockReachedInPromoInProgress)
						? (props) => moment(props.row.dateAllocatedStockReachedInPromoInProgress).format('DD/MM/YYYY HH:mm')
						: '-',
				sortableId: 'pcl.lastModifiedDate',
			},
			{
				columnReferential: 'kioskPrice_promotionScheduled',
				dataHook: 'numberOfScheduledPromotion',
				headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_tableHeader_sheduledPromotionNumber'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'futurePromoNumber',
			},
		])
	}, [translations])
	// Used for columns displaying (redux stored)
	const tableReferential = {
		idPageTable: 3,
		labelPageTable: 'kioskPrice',
	}
	// Config
	const [configTable, setConfigTable] = useState({
		getSelected: (getSelectedData) => {
			// button to layout for get data selected ( getSelectedData is actions.edit.getDataSelected function )
			return (
				<>
					{!isUndefined(find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.action[2])) ? (
						<ActionWrapperElem>
							<Tooltip
								translationsKey={'tooltip__admin__priceManagement__createPriceCampaign'}
								tooltipId={'kioskPriceScheduledPriceCampaign'}
							>
								<ImgButton
									as={'div'}
									action={() => getSelectedData('price')}
									img={CreatePrice}
									color={theme.colors.primary}
									hover={theme.colors.hoverPrimary}
								/>
							</Tooltip>
						</ActionWrapperElem>
					) : null}

					{!isUndefined(find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.action[3])) ? (
						<ActionWrapperElem>
							<Tooltip
								translationsKey={'tooltip__admin__priceManagement__createPromoCampaign'}
								tooltipId={'kioskPriceScheduledPromoCampaign'}
							>
								<ImgButton
									as={'div'}
									img={CreatePromo}
									action={() => getSelectedData('promo')}
									color={theme.colors.primary}
									hover={theme.colors.hoverPrimary}
								/>
							</Tooltip>
						</ActionWrapperElem>
					) : null}
				</>
			)
		},

		nestedValues: {
			value: true,
			nestedData: 'pricesLine',
			nestedComponent: (props) => <KioskPricesManagerNested {...props} setRow={setNestedRow} />,
			nestedPointer: 'id', // To retrieve index of line which is nested toggled or not => nestedPointer = nestedPointerValuePath
			nestedPointerValuePath: 'props.row.id', // To retrieve value of line which is nested toggled or not => nestedPointer = nestedPointerValuePath
			toggleAllNestedPointer: 'toggleNested', // Are we seeing nested lines or not
		},
		actions: {
			edit:
				!isUndefined(find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.action[2])) ||
				!isUndefined(find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.action[3]))
					? {
							getDataSelected: (data, target) => {
								// action to execute when getSelected data is click. dataCp is array of object => selected data
								handlePriceOrPromo(data, target)
							},
					  }
					: null,
			/* Is useless ?
			toggleLists: [
				() => (
					<TooltipHelp
						content={ "tooltipHelp__admin__modal__body__table__filter__vatSwitch" }
						childrenPos={ 2 }
					>
						<ToggleFilters
							defaultChecked
							onChangeHandler={ handleWithTTC }
							name="withTTC"
							labelPrev={ translations['page__global__admin__header_priceSwitch_priceHT'] }
							labelNext={ translations['page__global__admin__header_priceSwitch_priceTTC'] }
						/>
					</TooltipHelp>
				),
			],*/
		},
	})

	const [configTableTitle, setConfigTableTitle] = useState({
		actions: {},
		paging: {
			fnSendTo: (paging) => handlePagingSalesHistory(paging),
		},
	})

	////////////////////////////////USE EFFECT/////////////////////////////////////////

	useEffect(() => {
		return function cleanUp() {
			actionsTable.resetPaggingConfig()
		}
	}, [])

	useEffect(() => {
		const isPriceTTC = user.identity.isPricesTTC
		if (isUndefined(user) || isEmpty(translations)) return
		if (isEmpty(filters)) {
			const filtersCp = {
				withFilters: false,
				searchFieldByItem: null,
				pricesTTC: isPriceTTC,

				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},
				searchFieldUpdated: false,
			}
			actionsKioskPricesManager.postKioskPricesManager(filtersCp)
			actionsColumns.setColumns([])
		}
	}, [user, translations])

	useEffect(() => {
		setFilters(kioskPricesFilters)
		setPrevFilter(kioskPricesFilters)
	}, [kioskPricesFilters])

	//to table title
	useEffect(() => {
		const cfg = cloneDeep(configTableTitle)
		cfg.paging = {
			totalElements: kioskPricesManager.paging.totalElements,
			totalPages: kioskPricesManager.paging.totalPages,
			fnSendTo: (paging) => handlePagingSalesHistory(paging),
		}
		setConfigTableTitle(cfg)
		setInputData(kioskPricesManager.items)
	}, [kioskPricesManager])

	// to table title
	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)
		cfg.name = translations['page__pricesManagement__pricesByKiosk_title']
		cfg.actions.toggleLists = [
			() => (
				<TooltipHelp content={'tooltipHelp__admin__modal__body__table__filter__vatSwitch'} childrenPos={2}>
					<ToggleFilters
						checked={filters.pricesTTC}
						onChangeHandler={handleWithTTC}
						size={'large'}
						name="withTTC"
						labelPrev={translations['page__global__admin__header_priceSwitch_priceHT']}
						labelNext={translations['page__global__admin__header_priceSwitch_priceTTC']}
					/>
				</TooltipHelp>
			),
		]
		cfg.paging = {
			totalElements: kioskPricesManager.paging.totalElements,
			totalPages: kioskPricesManager.paging.totalPages,
			fnSendTo: (paging) => handlePagingSalesHistory(paging),
		}
		cfg.actions.rest = [
			() => (
				<DropdownCheckbox
					title={translations['page__pricesManagement__pricesByKiosk__admin__header__filter_distributor']}
					data={filters.filtersSelection?.distributors.filterElements || []}
					translations={translations}
					radio={true}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={() => handleSubmitFilter}
					target={'distributors'}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['page__pricesManagement__pricesByKiosk__admin__header__filter_currency']}
					data={filters.filtersSelection?.currencies.filterElements || []}
					translations={translations}
					radio={true}
					labelToDisplay
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={() => handleSubmitFilter}
					target={'currencies'}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['page__pricesManagement__pricesByKiosk__admin__header__filter_kiosk']}
					data={filters.filtersSelection?.kiosks.filterElements || []}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmitFilter}
					target={'kiosks'}
				/>
			),

			() => (
				<DropdownCheckbox
					title={translations['page__pricesManagement__pricesByKiosk__admin__header__filter_familly']}
					data={filters.filtersSelection?.famillies.filterElements || []}
					translations={translations}
					toTranslate
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmitFilter}
					target={'famillies'}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['page__pricesManagement__pricesByKiosk__admin__header__filter_brand']}
					data={filters.filtersSelection?.brands.filterElements || []}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmitFilter}
					target={'brands'}
				/>
			),
		]

		setConfigTableTitle(cfg)
	}, [translations, prevFilter, filters])

	useEffect(() => {
		const cfgCp = cloneDeep(configTable)

		cfgCp.export = {
			privilege: userPrivileges.export[1],
			url: urlExport[8],
			bd: {
				filtersSelection: filters.filtersSelection,
				pricesTTC: filters.pricesTTC,
				searchFieldByItem: searchValue,
				withFilters: true,
				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},
			},
		}
		cfgCp.actions.edit = !isUndefined(find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.action[2]))
			? {
					getDataSelected: (data, target) => {
						// action to execute when getSelected data is click. dataCp is array of object => selected data
						handlePriceOrPromo(data, target)
					},
			  }
			: null
		setConfigTable(cfgCp)
	}, [translations, prevFilter, filters])

	// to table title
	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)

		cfg.actions.searchBarComponent = {
			handleSearchEnter: handleSearchEnter,
			handleClickSearch: handleClickSearch,
			placeholder: translations['common__text__fastFilter_search'],
			handleReset: (refInput) => {
				refInput.current.value = ''
				setSearchValue('')
			},
		}

		setConfigTableTitle(cfg)
	}, [searchValue])

	// Moved content inside campaign modal to avoid loops

	// If user is changing his perimeter, we need to make a back call
	useEffect(() => {
		if (!isEqual(userKioskPerimeter, currentPerimeterKiosks) && !isEmpty(currentPerimeterKiosks))
			//actionsKioskPricesManager.postKioskPricesManager(handleFilterSend(), paging)
			actionsKioskPricesManager.postKioskPricesManager(
				{
					pricesTTC: user.identity.isPricesTTC,
					withFilters: false,
					userKioskScope: {
						kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
					},
				},
				paging
			)
		setCurrentPerimeterKiosks(userKioskPerimeter)
	}, [userKioskPerimeter])

	useEffect(() => {
		// Waiting that campaign is not empty before opening modal ?
		if (!isEqual(campaign, {}) && !showModalEditCampaign) setShowModalEditCampaign(true)
	}, [campaign])

	useEffect(() => {
		// Waiting that promo is not empty before opening modal ?
		if (!isEqual(campaignPromo, {}) && !showModalEditCampaignPromo) setShowModalEditCampaignPromo(true)
	}, [campaignPromo])

	useEffect(() => {
		if (filters.searchFieldByItem !== searchValue) return
		handleSubmitFilter()
	}, [filters.searchFieldByItem])

	useEffect(() => {
		if (isUndefined(searchValue)) return
		const filtersCP = cloneDeep(filters)
		filtersCP.searchFieldByItem = searchValue
		setFilters(filtersCP)
	}, [searchValue])

	const TableRender = useMemo(() => {
		return (
			<Table
				inputColumns={columns}
				inputData={kioskPricesManager.items}
				inputConfig={configTable}
				currentPaging={paging}
				isLoading={kioskPricesManager.isLoading}
				tableReferential={tableReferential}
				actionSort={actionsKioskPricesManager.postKioskPricesManager}
			/>
		)
	}, [kioskPricesManager, columns, configTable, translations, paging])

	//////////////////////////////////// RENDER /////////////////////////////////////////////////////////
	const handleTest = () => {
		setShowModalEditCampaign(false)
	}

	return (
		<Fragment>
			{!isUndefined(filters.pricesTTC) /*row.kiosks?.length &&*/ && (
				<PriceCampaignHandlerCreate
					closeModalHandler={() => {
						handleTest()
						handleSubmitFilter(true)
						campaignActions.resetCampaignItems()
					}}
					showModal={showModalEditCampaign}
					//data={ cloneDeep( row ) }
					//setRow={ setRow }
					widthTaxes={filters.pricesTTC}
					campaignErrors={campaignErrors}
					successCreateCampaign={successCreateCampaign}
					target={'byKiosk'}
					filters={filters}
				/>
			)}
			{!isUndefined(filters.pricesTTC) /*row.kiosks?.length &&*/ && (
				<PromoCampaignHandlerCreate
					closeModalHandler={() => {
						setShowModalEditCampaignPromo(false)
						handleSubmitFilter(true)
						campaignPromoActions.resetCampaignPromoItems()
					}}
					showModal={showModalEditCampaignPromo}
					//data={ cloneDeep( row ) }
					//setRow={ setRow }
					widthTaxes={filters.pricesTTC}
					campaignErrors={campaignPromoErrors}
					successCreateCampaign={successCreateCampaignPromo}
					target={'byKiosk'}
					filters={filters}
				/>
			)}

			<NestedUpdateCampaign
				nestedRow={nestedRow}
				setNestedRow={setNestedRow}
				withTaxes={filters.pricesTTC}
				handleSubmitFilter={handleSubmitFilter}
			/>

			<Modals
				closeModalHandler={() => setShowModalCancelCampaign(false)}
				showModal={showModalCancelCampaign}
				title={translations['modal__pricesManagement__pricesCampaign_cancelation_title']}
				icon={true}
			>
				<TextModal>
					<p>{translations['modal__pricesManagement__pricesCampaign_cancelation_message']}</p>
				</TextModal>
				<ButtonWrapper>
					<Button
						actionHandler={() => setShowModalCancelCampaign(false)}
						text={translations['common__text__cancel']}
						bgColor={theme.colors.error}
						margin="true"
						img={Cancel}
					/>

					<Button
						actionHandler={() => {
							//handleModalCancelCampaign(row)
						}}
						text={translations['common__text__validate']}
						bgColor={theme.colors.validation}
						img={Validation}
					/>
				</ButtonWrapper>
			</Modals>

			<UsersManagerWrapper>
				{!isUndefined(translations) && !isUndefined(configTableTitle) && (
					<TableTitle inputConfig={configTableTitle} inputColumns={columns} tableReferential={tableReferential} />
				)}
				{!isUndefined(translations) && !isUndefined(configTable) && TableRender}
			</UsersManagerWrapper>
		</Fragment>
	)
}

KioskPricesManager.propTypes = {}

KioskPricesManager.defaultPropTypes = {}

export default KioskPricesManager
